import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "../../css/Wedding.css";

import anhPhongSuCuoi from "../../assets/images/anh-cuoi-phong-su.jpg";
import anhCuoiTruyenThong from "../../assets/images/anh-cuoi-truyen-thong.jpg";
import anhPhimPhongSuCuoi from "../../assets/images/anh-phim-phong-su-cuoi.jpg";
import anhPhimCuoiTruyenThong from "../../assets/images/anh-phim-cuoi-truyen-thong.jpg";
// import anhFlycam from "../../assets/images/anh-flycam.jpg";

// Danh sách dịch vụ cưới
const services = [
    {
        title: "Hình Phóng Sự Cưới",
        path: "/AnhPhongSuCuoi",
        image: anhPhongSuCuoi,
        description: "Lưu giữ những khoảnh khắc tự nhiên và cảm xúc.",
    },
    {
        title: "Hình Cưới Truyền Thống",
        path: "/AnhCuoiTruyenThong",
        image: anhCuoiTruyenThong,
        description: "Ghi lại trọn vẹn nghi lễ và nét đẹp gia đình.",
    },
    {
        title: "Phim Phóng Sự Cưới",
        path: "/PhimPhongSuCuoi",
        image: anhPhimPhongSuCuoi,
        description: "Kể câu chuyện tình yêu bằng ngôn ngữ điện ảnh.",
    },
    {
        title: "Phim Cưới Truyền Thống",
        path: "/PhimCuoiTruyenThong",
        image: anhPhimCuoiTruyenThong,
        description: "Lưu giữ đầy đủ những nghi thức trong ngày cưới.",
    },

    // Tạm ẩn Flycam, khi muốn mở lại thì bỏ dấu // ở các dòng bên dưới
    // {
    //     title: "Flycam Teambuilding",
    //     path: "/Flycam",
    //     image: anhFlycam,
    //     description: "Góc nhìn toàn cảnh cho sự kiện và hoạt động.",
    // },
];

export default function HomePagePanel() {
    const navigate = useNavigate();

    return (
        <Container fluid className="wedding-page">
            {/* Phần giới thiệu */}
            <div className="wedding-text">
                <h1>
                    Every photo tells a story, every moment is a cherished memory.
                </h1>

                <p>
                    Lưu giữ những khoảnh khắc đáng nhớ cùng MinMin Wedding - Phóng Sự Cưới.
                </p>
            </div>

            {/* Danh sách dịch vụ */}
            <Row className="service-row">
                {services.map((service) => (
                    <Col
                        key={service.path}
                        xs={12}
                        sm={6}
                        lg={6}
                        className="service-column"
                    >
                        <div
                            className="service-inform"
                            style={{
                                backgroundImage: `url("${service.image}")`,
                            }}
                        >
                            <div className="service-overlay">
                                <h2>{service.title}</h2>

                                <p>{service.description}</p>

                                <Button
                                    type="primary"
                                    block
                                    onClick={() => navigate(service.path)}
                                >
                                    Xem thêm
                                </Button>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}